import { GUEST_FREE_HINTS_INITIAL } from "./hintPointsConstants";

export const GUEST_HINTS_STORAGE_KEY = "sliding-guest-free-hints";

export const GUEST_HINTS_FORFEITED_KEY = "sliding-guest-hints-forfeited";

export const GUEST_HINTS_CHANGED_EVENT = "sliding-guest-hints-changed";

function readBalance() {
    try {
        const raw = localStorage.getItem(GUEST_HINTS_STORAGE_KEY);
        if (raw == null || raw === "") {
            return null;
        }
        const n = Number(raw);
        return Number.isFinite(n) && n >= 0 ? Math.floor(n) : null;
    } catch {
        return null;
    }
}

function writeBalance(value) {
    const n = Number(value);
    if (!Number.isFinite(n) || n < 0) {
        return;
    }
    try {
        localStorage.setItem(GUEST_HINTS_STORAGE_KEY, String(Math.floor(n)));
        window.dispatchEvent(
            new CustomEvent(GUEST_HINTS_CHANGED_EVENT, {
                detail: { balance: Math.floor(n) },
            }),
        );
    } catch {
        /* quota or private mode */
    }
}

export function isGuestHintsForfeited() {
    try {
        return localStorage.getItem(GUEST_HINTS_FORFEITED_KEY) === "1";
    } catch {
        return false;
    }
}

/** After sign-in or any IAP — server wallet only; do not recharge 200 on sign-out. */
export function forfeitGuestFreeHints() {
    try {
        localStorage.setItem(GUEST_HINTS_FORFEITED_KEY, "1");
        localStorage.removeItem(GUEST_HINTS_STORAGE_KEY);
        window.dispatchEvent(
            new CustomEvent(GUEST_HINTS_CHANGED_EVENT, {
                detail: { balance: 0, cleared: true, forfeited: true },
            }),
        );
    } catch {
        /* ignore */
    }
}

export function ensureGuestFreeHintsInitialized(initial = GUEST_FREE_HINTS_INITIAL) {
    if (isGuestHintsForfeited()) {
        return 0;
    }
    const current = readBalance();
    if (current != null) {
        return current;
    }
    const start = Math.max(0, Math.floor(Number(initial) || 0));
    writeBalance(start);
    return start;
}

export function getGuestFreeHintBalance() {
    if (isGuestHintsForfeited()) {
        return 0;
    }
    return readBalance() ?? 0;
}

export function hasGuestFreeHintWallet() {
    return !isGuestHintsForfeited() && readBalance() != null;
}

export function deductGuestFreeHint(amount = 1) {
    if (isGuestHintsForfeited()) {
        return 0;
    }
    const cost = Number(amount);
    if (!Number.isFinite(cost) || cost <= 0) {
        return getGuestFreeHintBalance() || ensureGuestFreeHintsInitialized();
    }
    const current =
        readBalance() != null ? readBalance() : ensureGuestFreeHintsInitialized();
    const next = Math.max(0, current - Math.floor(cost));
    writeBalance(next);
    return next;
}
